import Enum from '../utils/enum'

const NetworkStatus = new Enum([
  'ONLINE',
  'OFFLINE',
  'CONNECTING',
  'UNREACHABLE',
])

export default NetworkStatus
